import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { ContactMethodFormatter } from '@pbx/services/formatter/ContactMethod';
import { DATA, PER_PAGE } from '@/plugins/vuex-async-pagginate';
import { META } from 'vuex-async-paginate/src/const';

class ContactMethodServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params = {}) {
    return this.pure_http.get('/pbx/client/contact-methods', { params: params }).then(res => ({
      [META]: res[META],
      [DATA]: ContactMethodFormatter.formatItems(res[DATA])
    }));
  }

  getSelect(params = {}) {
    return this.getList({ ...params, [PER_PAGE]: 500 }).then(res => res[DATA]);
  }

  editItem(contact_id, id, params) {
    return this.http.put(`/${contact_id}/methods/${id}`, params);
  }

  removeItem(contact_id, id) {
    return this.http.delete(`/${contact_id}/methods/${id}`);
  }

  createItem(contact_id, params) {
    return this.http.post(`/${contact_id}/methods`, params);
  }

  getAll(params = {}) {
    return this.getList({ ...params, [PER_PAGE]: 500 }).then(res => res[DATA]);
  }

  getByContactId(contact_id, params) {
    return this.http.get(`/${contact_id}/methods`, { params: params }).then(res => ({
      [META]: res[META],
      [DATA]: ContactMethodFormatter.formatItems(res[DATA])
    }));
  }

  getAllByGroup(group_id, params = {}) {
    return this.getAll({ ...params, group_id: group_id });
  }

  getAllByContactId(contact_id, params = {}) {
    return this.getByContactId(contact_id, { ...params, [PER_PAGE]: 500 }).then(res => res[DATA]);
  }
}

export const ContactMethodService = new ContactMethodServiceClass({
  api_version: 2,
  resource: 'pbx/contacts'
});
